import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

/** All Tabs that are shown all UI. */
export const TAB = {
  ORDERS: globalTranslate('title.orders'),
  CLASS_REGISTRATIONS: globalTranslate('title.classRegistrations'),
  PROCTOR_U_REGISTRATIONS: globalTranslate('title.proctorURegistrations'),
  ADMIN_E_LEARNING: globalTranslate('title.adminELearning'),
  STUDENT_E_LEARNING: globalTranslate('title.studentELearning'),
  LEARNERS: globalTranslate('title.learners'),
  ALL: 'All',
  ACTIVE_COURSES: globalTranslate('courseStatus.active'),
  COMPLETED_COURSES: globalTranslate('courseStatus.completed'),
  PAYMENT_INFO: 'Payment',
  PACKAGE_INFO: 'Package'
};

export const TAB_VALUE = {
  ORDERS: 'orders',
  CLASS_REGISTRATIONS: 'class_registrations',
  PROCTOR_U_REGISTRATIONS: 'proctor_u_registrations',
  ADMIN_E_LEARNING: 'admin_e_learning',
  STUDENT_E_LEARNING: 'student_e_learning',
  LEARNERS: 'learners',
  ALL: 'all',
  IN_PERSON: 'in_person',
  ONLINE: 'online_courses',
  ACTIVE_COURSES: 'active_courses',
  COMPLETED_COURSES: 'completed_courses',
  PAYMENT_INFO: 'payment_info',
  PACKAGE_INFO: 'package_info'
};

export const PFS_ADMIN_TABS = [
  TAB_VALUE.ORDERS,
  TAB_VALUE.CLASS_REGISTRATIONS,
  TAB_VALUE.PROCTOR_U_REGISTRATIONS,
  TAB_VALUE.ADMIN_E_LEARNING,
  TAB_VALUE.LEARNERS,
];

export const PFS_LEARNER_TABS = [
  TAB_VALUE.ALL,
  TAB_VALUE.CLASS_REGISTRATIONS,
  TAB_VALUE.PROCTOR_U_REGISTRATIONS,
  TAB_VALUE.STUDENT_E_LEARNING,
];

export const GROUP_ADMIN_TABS = [
  TAB_VALUE.ORDERS,
  TAB_VALUE.CLASS_REGISTRATIONS,
  TAB_VALUE.PROCTOR_U_REGISTRATIONS,
  TAB_VALUE.ADMIN_E_LEARNING,
  TAB_VALUE.LEARNERS,
];

export const STUDENT_TABS = [
  TAB_VALUE.CLASS_REGISTRATIONS,
  TAB_VALUE.PROCTOR_U_REGISTRATIONS,
  TAB_VALUE.STUDENT_E_LEARNING,
];

export const COURSE_TABS = [
  TAB_VALUE.ACTIVE_COURSES,
  TAB_VALUE.COMPLETED_COURSES
];

export const ORDERS_TABS = [
  TAB_VALUE.PAYMENT_INFO
];